if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			onSubmitHandler(evt) {

				evt.preventDefault();

				// const customerTag = evt.target.querySelector('button.product-form__submit').getAttribute("data-customer-tag");
				const submitBtn = evt.target.querySelector('button.product-form__submit');
				const customerTag = submitBtn ? submitBtn.getAttribute('data-customer-tag') : null;

				if (customerTag === "Wholesale") {
					
					if (this.submitButton.getAttribute("aria-disabled") === "true") return;

					this.handleErrorMessage();

					this.submitButton.setAttribute("aria-disabled", true);
					this.submitButton.classList.add("loading");
					if (this.querySelector(".loading-overlay__spinner")) {
						this.querySelector(".loading-overlay__spinner").classList.remove("hidden");
					}

					const config = fetchConfig("javascript");
					config.headers["X-Requested-With"] = "XMLHttpRequest";
					delete config.headers["Content-Type"];

					// --- Start: Collect all active variants ---
					const items = [];
					document.querySelectorAll(".itg_wholesale_variant_part.active").forEach((wrapper) => {
						const input = wrapper.querySelector(".quantity__input");
						const qty = parseInt(input.value) || 0;
						const variantId = parseInt(wrapper.dataset.wholesaleId); 
						const propertyInput = document.querySelector(".itg_product_properties");
						const propertyValue = propertyInput ? propertyInput.value.trim() : "";						
						const singalpropertyInput = document.querySelector(".itg_bundle_singal");
						const singalpropertyValue = singalpropertyInput ? singalpropertyInput.value.trim() : "";

						if (qty > 0 && variantId) {

							var properties = {};
							if (propertyValue !== "") {
								properties.Bundle = propertyValue;
							}

								// Add only if value is not blank
								if (singalpropertyValue !== "") {
									properties._single_item = singalpropertyValue;
								}

								items.push({
									id: variantId,
									quantity: qty,
									properties: properties
								});
						}
					});


					// const bundle_items = [];
					// document.querySelectorAll(".itg_bundle_ID").forEach((wrapper) => {
					// 	 const variantId = parseInt(wrapper.getAttribute('data-bundle-id')); 
					// 	const qty = parseInt(wrapper.getAttribute('data-bundle-qty')) || 0;

					// 	if (qty > 0 && variantId) {
					// 		bundle_items.push({ id: variantId, quantity: qty });
					// 	}
					// });

					if (items.length === 0) {
						this.submitButton.removeAttribute("aria-disabled");
						this.submitButton.classList.remove("loading");
						return;
					}

					const formData = new FormData();

					items.forEach((item, index) => {
						formData.append(`items[${index}][id]`, item.id);
						formData.append(`items[${index}][quantity]`, item.quantity);
						for (const [key, value] of Object.entries(item.properties)) {
							formData.append(`items[${index}][properties][${key}]`, value);
						}
					});

					// bundle_items.forEach((item, index) => {
					// 	//const newIndex = items.length + index; // continue index after normal items
					// 	formData.append(`items[${index}][id]`, item.id);
					// 	formData.append(`items[${index}][quantity]`, item.quantity);
					// });

					// items.forEach(item => {
					// 	formData.append("items[][id]", item.id);
					// 	formData.append("items[][quantity]", item.quantity);
					// });


					// Add sections if cart is used
					if (this.cart) {
						formData.append(
						"sections",
						this.cart.getSectionsToRender().map(section => section.id)
						);
						formData.append("sections_url", window.location.pathname);
						this.cart.setActiveElement(document.activeElement);
					}
					config.body = formData;
					// --- End: Collect all active variants ---

					fetch(`${routes.cart_add_url}`, config)
						.then(response => response.json())
						.then(response => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
							source: "product-form",
							errors: response.description,
							message: response.message
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
							if (soldOutMessage) {
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							}
							this.error = true;
							return;
						}

						if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error) {
							publish(PUB_SUB_EVENTS.cartUpdate, {
							source: "product-form"
							});
						}
						this.error = false;

						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
							"modalClosed",
							() => {
								setTimeout(() => this.cart.renderContents(response));
							},
							{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
						})
						.catch(e => console.error(e))
						.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						if (this.querySelector(".loading-overlay__spinner")) {
							this.querySelector(".loading-overlay__spinner").classList.add("hidden");
						}
						});
				

				}else{

					//evt.preventDefault();
					if (this.submitButton.getAttribute("aria-disabled") === "true") return;

					this.handleErrorMessage();

					this.submitButton.setAttribute("aria-disabled", true);
					this.submitButton.classList.add("loading");
					if (this.querySelector(".loading-overlay__spinner")) {
						this.querySelector(".loading-overlay__spinner").classList.remove(
							"hidden"
						);
					}

					const config = fetchConfig("javascript");
					config.headers["X-Requested-With"] = "XMLHttpRequest";
					delete config.headers["Content-Type"];

					// const bundle_items = [];
					// document.querySelectorAll(".itg_bundle_ID").forEach((wrapper) => {
					// 	const variantId = parseInt(wrapper.getAttribute('data-bundle-id')); 
					// 	const qty = parseInt(wrapper.getAttribute('data-bundle-qty')) || 0;

					// 	if (qty > 0 && variantId) {
					// 		bundle_items.push({ id: variantId, quantity: qty });
					// 	}
					// });

					
					// let formData; // declare once

					// if (document.querySelector('.itg_bundle_id_main')) {
					// 	formData = new FormData(); // assign, do NOT use let again
					// } else {
					// 	formData = new FormData(this.form); // assign, do NOT use let again
					// }


					// bundle_items.forEach((item, index) => {
					// 	//const newIndex = items.length + index; // continue index after normal items
					// 	formData.append(`items[${index}][id]`, item.id);
					// 	formData.append(`items[${index}][quantity]`, item.quantity);
					// });
					
					const formData = new FormData(this.form);
					if (this.cart) {
						formData.append(
							"sections",
							this.cart.getSectionsToRender().map((section) => section.id)
						);
						formData.append("sections_url", window.location.pathname);
						this.cart.setActiveElement(document.activeElement);
					}
					config.body = formData;

					fetch(`${routes.cart_add_url}`, config)
						.then((response) => response.json())
						.then((response) => {
							if (response.status) {
								publish(PUB_SUB_EVENTS.cartError, {
									source: "product-form",
									productVariantId: formData.get("id"),
									errors: response.description,
									message: response.message,
								});
								this.handleErrorMessage(response.description);

								const soldOutMessage =
									this.submitButton.querySelector(".sold-out-message");
								if (!soldOutMessage) return;
								this.submitButton.setAttribute("aria-disabled", true);
								this.submitButton.querySelector("span").classList.add("hidden");
								soldOutMessage.classList.remove("hidden");
								this.error = true;
								return;
							} else if (!this.cart) {
								window.location = window.routes.cart_url;
								return;
							}

							if (!this.error)
								publish(PUB_SUB_EVENTS.cartUpdate, {
									source: "product-form",
									productVariantId: formData.get("id"),
								});
							this.error = false;
							const quickAddModal = this.closest("quick-add-modal");
							if (quickAddModal) {
								document.body.addEventListener(
									"modalClosed",
									() => {
										setTimeout(() => {
											this.cart.renderContents(response);
										});
									},
									{ once: true }
								);
								quickAddModal.hide(true);
							} else {
								this.cart.renderContents(response);
							}
						})
						.catch((e) => {
							console.error(e);
						})
						.finally(() => {
							this.submitButton.classList.remove("loading");
							if (this.cart && this.cart.classList.contains("is-empty"))
								this.cart.classList.remove("is-empty");
							if (!this.error) this.submitButton.removeAttribute("aria-disabled");
							if (this.querySelector(".loading-overlay__spinner")) {
								this.querySelector(".loading-overlay__spinner").classList.add(
									"hidden"
								);
							}
						});
				}
			}









			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}


